import axios from 'axios';
import get from 'lodash/get';

export const ISSUE_SEARCH_RESULTS_LOADING = 'ISSUE_SEARCH_RESULTS_LOADING';
export const ISSUE_SEARCH_RESULTS_SUCCESS = 'ISSUE_SEARCH_RESULTS_SUCCESS';
export const ISSUE_SEARCH_RESULTS_ERROR = 'ISSUE_SEARCH_RESULTS_ERROR';

export const REFUND_STATUS_OPTIONS_LOADING = 'REFUND_STATUS_OPTIONS_LOADING';
export const REFUND_STATUS_OPTIONS_SUCCESS = 'REFUND_STATUS_OPTIONS_SUCCESS';
export const REFUND_STATUS_OPTIONS_ERROR = 'REFUND_STATUS_OPTIONS_ERROR';

export function fetchResourceStatusOptions() {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.user.token) return;

    dispatch({ type: REFUND_STATUS_OPTIONS_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/admin/refund-status-options`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: REFUND_STATUS_OPTIONS_SUCCESS,
          payload: response.data
        });
      })
      .catch(error => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: REFUND_STATUS_OPTIONS_ERROR,
          payload: response
        });
      });
  };
}

export function searchIssues(opts = {}) {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.user.token) return;

    const query =
      Object.entries(opts).length === 0 ? '' : '?' + new URLSearchParams(opts).toString();

    dispatch({ type: ISSUE_SEARCH_RESULTS_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/admin/issues${query}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: ISSUE_SEARCH_RESULTS_SUCCESS,
          payload: response.data
        });
      })
      .catch(error => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: ISSUE_SEARCH_RESULTS_ERROR,
          payload: response
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/Admin/issueActions.js